import * as yup from 'yup';

export const schemaConvenienceFee = yup.object({
  paypal_convenience_fee: yup.number().required('Field Required'),
  stripe_convenience_fee: yup.number().required('Field Required'),
});

export type ConvenienceFeeFormData = yup.InferType<typeof schemaConvenienceFee>;

export type TDomesticTable = {
  id: number;
  stateZipCode: string;
  taxRate: number;
  applyTaxToShipping: string;
  status: boolean;
};

export type TInternationalTable = {
  id: number;
  country: string;
  taxRate: number;
  applyTaxToShipping: string;
  status: boolean;
};

export enum ConfigureSaleTaxBy {
  State = 'state',
  ZipCode = 'zip_code',
}

export enum ZipCodeType {
  Specific = 'specific',
  Range = 'range',
}

export const schemaDomesticSalesFee = yup.object({
  configure_sales_tax: yup.string().required('Field Required'),
  state: yup.string().optional(),
  zip_code: yup.string().optional(),
  specific: yup.string().optional(),
  range_from: yup.string().optional(),
  range_to: yup.string().optional(),
  tax_rate: yup.number().required('Field Required'),
  apply_tax_to_shipping: yup.boolean().required('Field Required'),
});

export type DomesticSalesFeeFormData = yup.InferType<
  typeof schemaDomesticSalesFee
>;

export const schemaInternationalSalesFee = yup.object({
  country: yup.string().required('Field Required'),
  tax_rate: yup.number().required('Field Required'),
  apply_tax_to_shipping: yup.boolean().required('Field Required'),
});

export type InternationalSalesFeeFormData = yup.InferType<
  typeof schemaInternationalSalesFee
>;

export type ConvenienceFee = {
  id: number;
  paypal_convenience_fee: number;
  stripe_convenience_fee: number;
  paypal_tax: number;
};

export type ConvenienceFeeRes = {
  convenience_fee: ConvenienceFee;
};

export type SaleTaxRate = {
  country: string;
  state: string;
  name: string;
  rate: number;
  id: number;
};
